import * as Yup from 'yup';
import { endpoints } from 'src/utils/axios';

export const designationConfig = {
    // Entity metadata
    entity: {
        name: 'Designation',
        namePlural: 'Designations',
        apiEndpoint: endpoints.designationMaster,
        storageKey: 'designation-master-list-settings',
        rights: { module: 'hrm_management', menu: 'user_management', submenu: 'designation' },
    },

    // Data fetching configuration (optimized)
    fetch: {
        // Only fetch these fields for list view (table display)
        listFields: ['designation_name', 'status', 'createdAt', 'updatedAt'],
        // No populates needed for this simple module
        listPopulate: [],
    },

    // API endpoints
    endpoints: {
        list: endpoints.designationMaster.list,
        create: endpoints.designationMaster.create,
        update: (id) => endpoints.designationMaster.update(id),
        delete: (id) => endpoints.designationMaster.delete(id),
        getById: (id) => endpoints.designationMaster.details(id),  // Fetch individual record
    },

    // Form configuration
    form: {
        title: {
            create: 'Create New Designation',
            edit: 'Edit Designation',
        },
        fields: [
            {
                name: 'designation_name',
                label: 'Designation Name',
                type: 'text',
                placeholder: 'Enter designation name',
                validation: Yup.string()
                    .required('Designation name is required')
                    .min(2, 'Name must be at least 2 characters'),
                gridProps: { xs: 12 },
            },
            {
                name: 'status',
                label: 'Status',
                type: 'select',
                defaultValue: 'active',
                validation: Yup.string().required('Status is required'),
                options: [
                    { value: 'active', label: 'Active' },
                    { value: 'inactive', label: 'Inactive' },
                ],
                gridProps: { xs: 12 },
            },
        ],
        showAvatar: false,
        maxWidth: 'sm',
    },

    // Table configuration
    table: {
        columns: [
            {
                id: 'designation_name',
                label: 'Designation Name',
                width: 300,
                sortable: true,
                searchable: true,
                type: 'text',
            },
            {
                id: 'status',
                label: 'Status',
                width: 120,
                type: 'status',
                sortable: true,
                align: 'center',
                render: (value, row) => {
                    const status = value || 'inactive';
                    return {
                        label: status.charAt(0).toUpperCase() + status.slice(1),
                        color: status === 'active' ? 'success' : 'error',
                    };
                },
            },
            {
                id: 'createdAt',
                label: 'Created At',
                width: 150,
                type: 'date',
                sortable: true,
                format: 'dd MMM yyyy',
            },
        ],
        defaultSort: { field: 'createdAt', direction: 'desc' },
        rowsPerPageOptions: [5, 10, 25, 50],
        defaultRowsPerPage: 10,
    },

    // Filter configuration
    filters: {
        default: {
            search: '',
            status: 'all',
        },
        fields: [
            {
                name: 'search',
                label: 'Search',
                type: 'search',
                placeholder: 'Search designations...',
                apiParam: 'search',
            },
            {
                name: 'status',
                label: 'Status',
                type: 'tabs',
                options: [
                    { value: 'all', label: 'All', color: 'default' },
                    { value: 'active', label: 'Active', color: 'success' },
                    { value: 'inactive', label: 'Inactive', color: 'error' },
                ],
                apiParam: 'status',
                showCount: true,
            },
        ],
    },

    // Card view configuration
    card: {
        title: (item) => item.designation_name,
        subtitle: (item) => (item.status || 'inactive').charAt(0).toUpperCase() + (item.status || 'inactive').slice(1),
        avatar: false,
        status: (item) => {
            const status = item.status || 'inactive';
            return {
                label: status.charAt(0).toUpperCase() + status.slice(1),
                color: status === 'active' ? 'success' : 'error',
            };
        },
        metadata: [],
    },

    // Permissions & features
    features: {
        create: true,
        edit: true,
        delete: true,
        bulkDelete: true,
        export: true,
        duplicate: true,
        import: true,
        viewToggle: true,
        columnVisibility: true,
    },
};
